const FormItem = ({ label, children }) => {
  return (
    <div className="block mb-1">
      <label className="inline-block pr-2">{label}</label>
      <div className="inline-block">{children}</div>
    </div>
  )
}

export default FormItem
